import { z } from "zod";
import { AgencyIdSchema, ProjectIdSchema, RunIdSchema } from "../primitives/ids.js";
export const WebsiteOwnershipRecordIdSchema = z
    .string()
    .regex(/^ownrec_[a-zA-Z0-9_-]+$/)
    .brand();
export const WebsiteOwnershipChecklistItemStateSchema = z.enum([
    "unchecked",
    "noted",
    "confirmed",
]);
export const WebsiteOwnershipRiskScoreLabelSchema = z.enum(["Low", "Medium", "High"]);
export const WebsiteOwnershipChecklistItemV1Schema = z
    .object({
    schemaVersion: z.literal("website-ownership-checklist-item.v1.0"),
    itemId: z.string().min(1),
    label: z.string().min(1),
    state: WebsiteOwnershipChecklistItemStateSchema,
    note: z.string().min(1).nullable(),
})
    .strict();
/** Persisted ownership record checklist JSON shape. */
export const WebsiteOwnershipRecordV1Schema = z
    .object({
    schemaVersion: z.literal("website-ownership-record.v1.0"),
    ownershipRecordId: WebsiteOwnershipRecordIdSchema,
    agencyId: AgencyIdSchema,
    projectId: ProjectIdSchema,
    runId: RunIdSchema,
    checklist: z.array(WebsiteOwnershipChecklistItemV1Schema).min(1),
    riskScoreLabel: WebsiteOwnershipRiskScoreLabelSchema,
    updatedAt: z.string().datetime(),
})
    .strict();
export const ClientSafeWebsiteOwnershipViewV1Schema = z
    .object({
    schemaVersion: z.literal("client-safe-website-ownership-view.v1.0"),
    headline: z.string().min(1),
    subcopy: z.string().min(1),
    checklist: z.array(z
        .object({
        label: z.string().min(1),
        stateLabel: z.string().min(1),
        note: z.string().min(1).nullable(),
    })
        .strict()).min(1),
    riskScoreLabel: WebsiteOwnershipRiskScoreLabelSchema,
    riskScoreExplanation: z.string().min(1),
    disclaimers: z.array(z.string().min(1)).min(1),
    updatedAt: z.string().datetime(),
    clientSafe: z.literal(true),
})
    .strict();
export const AgencyWebsiteOwnershipViewV1Schema = z
    .object({
    schemaVersion: z.literal("agency-website-ownership-view.v1.0"),
    ownershipRecordId: WebsiteOwnershipRecordIdSchema,
    checklist: z.array(WebsiteOwnershipChecklistItemV1Schema).min(1),
    riskScoreLabel: WebsiteOwnershipRiskScoreLabelSchema,
    riskScoreExplanation: z.string().min(1),
    disclaimers: z.array(z.string().min(1)).min(1),
    updatedAt: z.string().datetime(),
})
    .strict();
/** DP-005 — North Star ownership dimensions (checklist itemIds). */
export const WEBSITE_OWNERSHIP_REQUIRED_DIMENSIONS = [
    "domain",
    "content",
    "assets",
    "artifact",
    "accounts",
    "responsibilities",
];
export function websiteOwnershipChecklistCoversRequiredDimensions(checklist) {
    const ids = new Set(checklist.map((item) => item.itemId));
    return WEBSITE_OWNERSHIP_REQUIRED_DIMENSIONS.every((dimension) => ids.has(dimension));
}
export const WebsiteOwnershipChecklistUpdateV1Schema = z
    .object({
    schemaVersion: z.literal("website-ownership-checklist-update.v1.0"),
    items: z
        .array(z
        .object({
        itemId: z.string().min(1),
        state: WebsiteOwnershipChecklistItemStateSchema,
        note: z.string().min(1).nullable().optional(),
    })
        .strict())
        .min(1),
})
    .strict();
//# sourceMappingURL=website-ownership-record.js.map